
// import featuredGallery15 from "../image/featured-project-gallery/project-gallery-15.png";
// import featuredGallery16 from "../image/featured-project-gallery/project-gallery-16.png";
// import featuredGallery17 from "../image/featured-project-gallery/project-gallery-17.png";
// import featuredGallery18 from "../image/featured-project-gallery/project-gallery-18.png";

// import vedEstate01 from "../image/architecture-projects/ved-estate-01.png";
// import vedEstate02 from "../image/architecture-projects/ved-estate-02.png";
// import nagpurCommercialElevation from "../image/architecture-projects/nagpur-commercial-elevation.jpg";
// import pastelBedroom from "../image/interior-projects/pastel-bedroom.png";
// import pastelUtilityKitchen from "../image/interior-projects/pastel-utility-kitchen.png";
// import pastelMainKitchen from "../image/interior-projects/pastel-main-kitchen.png";
// import pastelLivingDining01 from "../image/interior-projects/pastel-living-dining-01.png";
// import pastelLivingDining02 from "../image/interior-projects/pastel-living-dining-02.png";
// import pastelLivingDining03 from "../image/interior-projects/pastel-living-dining-03.png";
// import pastelBedroomStudy from "../image/interior-projects/pastel-bedroom-study.png";
// import pastelBedroomWardrobe from "../image/interior-projects/pastel-bedroom-wardrobe.png";

// import orchidTvUnit01 from "../image/interior-projects/orchid-tv-unit-01.jpeg";
// import orchidFoyer01 from "../image/interior-projects/orchid-foyer-01.jpeg";
// import orchidLiving01 from "../image/interior-projects/orchid-living-01.jpeg";
// import orchidKitchen01 from "../image/interior-projects/orchid-kitchen-01.jpeg";
// import kidsStudyBedroom from "../image/interior-projects/kids-study-bedroom.jpeg";

import goaFloorPlan01 from "../image/projects-grid-images/goa-image/ground-floor.png";
import goaFloorPlan02 from "../image/projects-grid-images/goa-image/1st-floor-plan.png";
import goaFloorPlan03 from "../image/projects-grid-images/goa-image/2nd-floor-plan.png";
import goaFloorPlan04 from "../image/projects-grid-images/goa-image/scatch.png";
import goaFloorRotate1 from "../image/projects-grid-images/goa-image/rotate-1st-floor.png";
import goaFloorRotate2 from "../image/projects-grid-images/goa-image/rotate-2nd-floor.png";
import goaFloorRotate3 from "../image/projects-grid-images/goa-image/rotate-ground-floor.png";


import shindeHouse1 from "../image/projects-grid-images/shinde-house-image/shinde house c bed.png"; 
import shindeHouse2 from "../image/projects-grid-images/shinde-house-image/kitchen.png";
import shindeHouse3 from "../image/projects-grid-images/shinde-house-image/ChatGPT Image Sep 18, 2026, 02_38_06 PM.png";
import shindeHouse4 from "../image/projects-grid-images/shinde-house-image/image3.png";
import shindeHouse5 from "../image/interior-image-ai/selected-AI-image/study-room-ai.png";
import shindeTransformationVideo from "../image/transformation.mp4";
import shindeFloorPlan1 from "../image/projects-grid-images/shinde-house-image/ground-floor-plan.png"
import shindeFloorPlan2 from "../image/projects-grid-images/shinde-house-image/1st-floor-plan.png"


import displayImage from "../image/featured-project-gallery/project-gallery-03.jpeg";
import riverstoneResidence from "../image/featured-project-gallery/project-gallery-04.png";
import aurangabadHouse from "../image/interior-projects/warm-living-tv-unit.jpeg";
import warmBedroom01 from "../image/interior-projects/warm-bedroom-01.jpeg";
import warmBedroom02 from "../image/interior-projects/warm-bedroom-02.jpeg";
import warmLiving01 from "../image/interior-projects/warm-living-01.jpeg";
import warmKitchen01 from "../image/interior-projects/warm-kitchen-01.jpeg";
import warmDining01 from "../image/interior-projects/warm-dining-01.jpeg";


import bungalowInterior1 from "../image/projects-grid-images/bunglow-image/warm-living-01.jpeg";
import bungalowInterior2 from "../image/projects-grid-images/bunglow-image/warm-kitchen-01.jpeg";
import bungalowInterior3 from "../image/projects-grid-images/bunglow-image/warm-bedroom-01-ai.png";
import bungalowInterior4 from "../image/projects-grid-images/bunglow-image/warm-dining-01-ai.png";
import heroSection from "../image/projects-grid-images/bunglow-image/warm-bedroom-06-ai.png";
import familyFocus from "../image/projects-grid-images/bunglow-image/warm-bedroom-03-ai.png";
import bigImage from "../image/projects-grid-images/bunglow-image/warm-living-tv-unit1.png";


// residential images 

import residencial1 from "../image/projects-grid-images/residential-image/project-gallery-03.jpeg"
import residencial2 from "../image/projects-grid-images/residential-image/project-gallery-02.jpeg"
import residencial3 from "../image/projects-grid-images/residential-image/before1.jpeg"


import featuredGallery01 from "../image/featured-project-gallery/project-gallery-01.png";
import featuredGallery02 from "../image/featured-project-gallery/project-gallery-02.jpeg";
import featuredGallery11 from "../image/featured-project-gallery/project-gallery-11.png";
import featuredGallery12 from "../image/featured-project-gallery/project-gallery-12.png";


export const PROJECT_DETAILS = {
  "shinde-house": {
    title: "Shinde House",
    category: "Residential / 3BHK Bunglow",
    facts: [
      { label: "Location", value: "Nigadi Pradhikaran, Pune" },
      { label: "Year", value: "2026" },
      { label: "Area", value: "2200 sq ft" },
      { label: "Category", value: "Residential" },
      { label: "Services", value: "Complete Renovation" },
    ],
    heroImage: shindeHouse1,
    heroAlt: "Shinde House interior in Nigadi Pradhikaran, Pune",
    overview:
      "Complete 3BHK bungalow renovation in Nigdi Pradhikaran, Pune, featuring modern bathroom renovation, electrical upgrades, contemporary flooring, and custom furniture design for a stylish and functional home.",
    fullbleedImage: shindeHouse2,
    fullbleedAlt: "Shinde House living space detail",
    fullbleedQuote: "Complete renovation creating a modern living environment with practical functionality.",
    chapters: [
      {
        eyebrow: "01 - IN THE MAKING",
        title: "Building the Details",
        body: "Interior work comes to life on site, with every element carefully installed to shape the home's final look and functionality.",
        video: shindeTransformationVideo,
        alt: "Shinde House interior work in progress",
      },
      {
        eyebrow: "02 - THE ENTRANCE",
        title: "A Strong First Impression",
        body: "A bold entrance combines clean geometry, metal detailing and contemporary character to set the tone for the home.",
        image: shindeHouse3,
        alt: "Shinde House contemporary entrance",
      },
      {
        eyebrow: "03 - THE WORKSPACE",
        title: "Designed to Work Beautifully",
        body: "A personalised study blends custom storage, a dedicated workspace and warm lighting to create a space that inspires focus.",
        image: shindeHouse5,
        alt: "Shinde House custom study and workspace",
      },
      {
        eyebrow: "04 - THE WARDROBE",
        title: "Storage with Style",
        body: "Thoughtfully designed wardrobes bring together ample storage, elegant finishes and subtle lighting without compromising the room's visual appeal.",
        image: shindeHouse4,
        alt: "Shinde House custom wardrobe and storage",
      },
    ],
    gallery: [
      {
        image: shindeHouse1,
        alt: "Shinde House custom bedroom interior with warm finishes",
        caption: "Bedroom with custom storage and soft lighting",
      },

     {
        image: shindeFloorPlan1,
        alt: "Shinde House custom bedroom interior with warm finishes",
        caption: "Bedroom with custom storage and soft lighting",
      },

       {
        image: shindeFloorPlan2,
        alt: "Shinde House custom bedroom interior with warm finishes",
        caption: "Bedroom with custom storage and soft lighting",
      },

      {
        image: shindeHouse2,
        alt: "Shinde House kitchen with modern cabinetry",
        caption: "Modular kitchen with clean working surfaces",
      },
      {
        image: shindeHouse3,
        alt: "Shinde House entrance door and wall detail",
        caption: "Entrance detail with bold door treatment",
      },
      {
        image: shindeHouse4,
        alt: "Shinde House wardrobe and storage wall",
        caption: "Wardrobe storage finished with a clean modern look",
      },
    ],
  },

  "residential-homes": {
    title: "Residential Project",
    category: "Residential / 2BHK Apartment",
    facts: [
      { label: "Location", value: "Wakad, Pune" },
      { label: "Year", value: "2026" },
      { label: "Area", value: "750 sq ft" },
      { label: "Category", value: "Residential" },
      { label: "Services", value: "Full Interior" },
    ],
    heroImage: residencial1,
    heroAlt: "Residential Project modern 2BHK living room",
    overview:
      "Full interior execution for a modern 2BHK apartment in Wakad, Pune. Designed with optimized space planning, custom modular kitchen, sleek built-in wardrobes, and subtle ambient living room lighting.",
    fullbleedImage: residencial1,
    fullbleedAlt: "Residential Project living interior",
    fullbleedQuote: "Clean lines and functional minimalism tailored for contemporary urban living.",
    chapters: [
      {
        eyebrow: "01 - SPATIAL PLANNING",
        title: "Optimized Living Space",
        body: "The living area uses warm neutral tones, custom TV console unit, and space-saving furniture to create a airy, open environment.",
        image: residencial2,
        alt: "Living space TV unit design",
      },
      {
        eyebrow: "02 - MODULAR KITCHEN",
        title: "Efficiency and Style",
        body: "Compact modular kitchen layout equipped with quartz countertops, soft-close drawers, and dedicated pantry storage.",
        image: residencial3,
        alt: "Modular kitchen layout",
      },
      // {
      //   eyebrow: "03 - BEDROOM SUITE",
      //   title: "Serene Private Retreat",
      //   body: "Master bedroom featuring floor-to-ceiling wardrobe with integrated vanity mirror and soft warm bedside illumination.",
      //   image: warmBedroom01,
      //   alt: "Master bedroom interior view",
      // },
    ],
    gallery: [
      {
        image: residencial1,
        alt: "Living area TV console detail",
        caption: "Living room with bespoke TV wall unit",
      },
      {
        image: residencial3,
        alt: "Modular kitchen",
        caption: "Dual-tone modular kitchen execution",
      },
      {
        image: residencial2,
        alt: "Master bedroom wardrobe",
        caption: "Custom wardrobe with soft backlighting",
      },
      // {
      //   image: warmDining01,
      //   alt: "Dining area nook",
      //   caption: "Compact dining corner with feature ceiling",
      // },
    ],
  },

  // "bunglow-interior": {
  //   title: "Bunglow Architecture & Interior",
  //   category: "Residential / 4BHK Bunglow",
  //   facts: [
  //     { label: "Location", value: "Vaijapur" },
  //     { label: "Year", value: "2025" },
  //     { label: "Area", value: "2500 sq ft" },
  //     { label: "Category", value: "Architecture & Interior" },
  //     { label: "Services", value: "Turnkey Execution" },
  //   ],
  //   heroImage: aurangabadHouse,
  //   heroAlt: "Bunglow interior TV unit and feature wall",
  //   overview:
  //     "Comprehensive architecture and interior project for a spacious 4BHK bungalow in Vaijapur. Harmonizing rich wooden veneer textures with contemporary spatial proportions across living, dining, and bedroom suites.",
  //   fullbleedImage: warmBedroom02,
  //   fullbleedAlt: "Bunglow bedroom interior detail",
  //   fullbleedQuote: "Harmonizing rich wood finishes with spacious architectural proportions.",
  //   chapters: [
  //     // {
  //     //   eyebrow: "01 - ARCHITECTURAL FACADE",
  //     //   title: "Sculpted Elevation",
  //     //   body: "Bold structural lines paired with warm exterior lighting give this bungalow a timeless and imposing street presence.",
  //     //   image: featuredGallery12,
  //     //   alt: "Bungalow architectural elevation",
  //     // },
  //     {
  //       eyebrow: "01 - GRAND LIVING ROOM",
  //       title: "Warm Wood Focus",
  //       body: "Spacious living zone anchored by a warm wood feature wall, marble flooring, and custom ceiling cove lighting.",
  //       image: aurangabadHouse,
  //       alt: "Living room wood paneling",
  //     },
  //     {
  //       eyebrow: "02 - BEDROOM SUITES",
  //       title: "Tailored Comfort",
  //       body: "Each bedroom suite has a unique design language, combining plush upholstered headboards with custom wardrobe solutions.",
  //       image: warmBedroom02,
  //       alt: "Bungalow master bedroom suite",
  //     },
  //   ],
  //   gallery: [
  //     {
  //       image: aurangabadHouse,
  //       alt: "TV Unit panel detail",
  //       caption: "Warm wood TV wall unit with fluted detail",
  //     },
  //     {
  //       image: warmBedroom02,
  //       alt: "Master bedroom layout",
  //       caption: "Master bedroom suite with textured headboard",
  //     },
  //     {
  //       image: warmBedroom01,
  //       alt: "Guest bedroom",
  //       caption: "Guest room with custom study desk",
  //     },
  //     {
  //       image: featuredGallery12,
  //       alt: "Exterior elevation",
  //       caption: "Modern bungalow elevation visual",
  //     },
  //   ],
  // },

  // "riverstone-residence": {
  //   title: "Goa Villa Residence",
  //   category: "Architecture & Villa / 4BHK",
  //   facts: [
  //     { label: "Location", value: "Goa" },
  //     { label: "Year", value: "2026" },
  //     { label: "Area", value: "1850 sq ft" },
  //     { label: "Category", value: "Architecture" },
  //     { label: "Services", value: "Villa Planning & Interior" },
  //   ],
  //   heroImage: riverstoneResidence,
  //   heroAlt: "Goa Villa Residence exterior facade",
  //   overview:
  //     "A tropical luxury villa residence designed in Goa featuring open-plan living, lush garden integration, indoor-outdoor fluidity, and contemporary tropical architectural language.",
  //   fullbleedImage: featuredGallery01,
  //   fullbleedAlt: "Goa Villa pool lounge",
  //   fullbleedQuote: "Seamlessly bridging interior sanctuary with coastal outdoor living.",
  //   chapters: [
  //     {
  //       eyebrow: "01 - ARCHITECTURAL VISION",
  //       title: "Coastal Living",
  //       body: "Designed to maximize natural breeze and light while offering total privacy and framing scenic tropical garden vistas.",
  //       image: riverstoneResidence,
  //       alt: "Villa exterior facade",
  //     },
  //     {
  //       eyebrow: "02 - OUTDOOR LOUNGE",
  //       title: "Alfresco Relaxation",
  //       body: "Shaded verandas, timber deck spaces, and poolside lounge seating created for effortless outdoor entertaining.",
  //       image: featuredGallery01,
  //       alt: "Poolside veranda design",
  //     },
  //     {
  //       eyebrow: "03 - INTERIOR FLOW",
  //       title: "Light & Air",
  //       body: "High ceilings, natural stone flooring, and warm teak wood elements carry through the entire living interior.",
  //       image: featuredGallery02,
  //       alt: "Villa living interior",
  //     },
  //   ],
  //   gallery: [
  //     {
  //       image: riverstoneResidence,
  //       alt: "Villa front view",
  //       caption: "Contemporary villa facade with timber screen",
  //     },
  //     {
  //       image: featuredGallery01,
  //       alt: "Lounge deck",
  //       caption: "Resort-inspired pool deck and lounge",
  //     },
  //     {
  //       image: featuredGallery02,
  //       alt: "Interior living area",
  //       caption: "Open-plan living room with outdoor garden views",
  //     },
  //   ],
  // },


"bunglow-interior": {
  title: "Bunglow Interior",

  category: "Residential / 4BHK Bunglow",

  facts: [
    { label: "Location", value: "Vaijapur" },
    { label: "Year", value: "2026" },
    { label: "Area", value: "2500 sq ft" },
    { label: "Category", value: "Residential" },
    { label: "Services", value: "Full Interior Design" },
  ],

  heroImage: heroSection,

  heroAlt: "Bunglow Interior in Vaijapur",

  overview:
    "A comprehensive interior design project for a 4BHK bunglow in Vaijapur. The design creates a warm, inviting living environment with careful attention to functionality, comfort, and aesthetic appeal throughout all spaces.",

  fullbleedImage: bigImage,

  fullbleedAlt: "Bunglow Interior kitchen design",

  fullbleedQuote:
    "Thoughtful interior design transforms a bunglow into a comfortable family home.",

  chapters: [
    {
      eyebrow: "01 - BEDROOM",
      title: "A Playful Space for Growing Up",
      body:
        "A smart bunk-bed setup combines sleep, storage and a warm wooden finish to make the room both practical and inviting.",
      image: familyFocus,
      alt: "Bungalow Interior bedroom with custom bunk bed",
    },

    {
      eyebrow: "02 - KITCHEN",
      title: "Clean, Modern & Functional",
      body:
        "A sleek modular kitchen brings together practical storage, clean finishes and warm lighting for effortless everyday living.",
      image: bungalowInterior2,
      alt: "Bungalow Interior modern modular kitchen",
    },

    {
      eyebrow: "03 - MASTER BEDROOM",
      title: "Warmth in Every Detail",
      body:
        "Soft tones, natural wood and integrated lighting create a calm bedroom designed for comfort and unwinding.",
      image: bungalowInterior3,
      alt: "Bungalow Interior master bedroom",
    },

    {
      eyebrow: "04 - DINING",
      title: "Designed to Gather Around",
      body:
        "A refined dining space pairs elegant cabinetry, warm textures and thoughtful lighting to make everyday meals feel special.",
      image: bungalowInterior4,
      alt: "Bungalow Interior dining area with modern cabinetry",
    },
  ],

  gallery: [
    {
      image: bungalowInterior3,
      alt: "Bunglow Interior warm master bedroom",
      caption: "Master bedroom with warm wood and soft lighting",
    },

    {
      image: bungalowInterior1,
      alt: "Bunglow Interior living room with TV unit",
      caption: "Living room with composed TV wall and seating",
    },

    {
      image: bungalowInterior2,
      alt: "Bunglow Interior modern modular kitchen",
      caption: "Modular kitchen with efficient storage and workflow",
    },

    {
      image: bungalowInterior4,
      alt: "Bunglow Interior dining space with cabinetry",
      caption: "Dining area with elegant cabinetry and warm finishes",
    },
  ],
},
  
  "goa-villa": { 
  title: "Goa Villa Residence",
  category: "Architecture & Villa / 4BHK",

  facts: [
    { label: "Location", value: "Goa" },
    { label: "Year", value: "2026" },
    { label: "Area", value: "1850 sq ft" },
    { label: "Category", value: "Architecture" },
    { label: "Services", value: "Villa Planning & Interior" },
  ],

  heroImage: riverstoneResidence ,
  heroAlt: "Goa Villa Residence architectural exterior",

  overview:
    "A proposed 4BHK villa residence in Goa planned around generous living spaces, private bedroom suites, landscaped outdoor areas, water features, and a strong connection between indoor and outdoor living.",

  fullbleedImage: goaFloorPlan04,
  fullbleedAlt: "Goa Villa outdoor living and pool area",
  fullbleedQuote:
    "A villa planned around open living, private retreats, and a strong connection with the landscape.",

  chapters: [
    {
      eyebrow: "01 - LANDSCAPE & WELLNESS",
      title: "A Landscape-Centered Arrival",
      body:
        "The plan begins with a carefully integrated outdoor environment featuring landscaped areas, a water body / baby pool, a semi-covered outdoor setout and a dedicated meditation area.",
      image: goaFloorPlan04,
      alt: "Goa Villa floor plan showing landscape, meditation area and water body",
    },

     {
      eyebrow: "02 - LANDSCAPE & WELLNESS",
      title: "A Landscape-Centered Arrival",
      body:
        "The plan begins with a carefully integrated outdoor environment featuring landscaped areas, a water body / baby pool, a semi-covered outdoor setout and a dedicated meditation area.",
      image: goaFloorPlan01,
      alt: "Goa Villa floor plan showing landscape, meditation area and water body",
    },


    {
      eyebrow: "03 - LIVING & FAMILY SPACES",
      title: "Designed Around Everyday Living",
      body:
        "The main living zone brings together the entrance lobby, living area, dining area, kitchen and pooja space. The layout keeps the primary family spaces connected while allowing direct access to balconies and outdoor areas.",
      image: goaFloorPlan02,
      alt: "Goa Villa floor plan showing living, dining, kitchen and family spaces",
    },

    {
      eyebrow: "04 - PRIVATE RETREATS",
      title: "Comfortable Private Suites",
      body:
        "The private areas are planned with spacious master and guest bedrooms, walk-in closets, dressing and storage areas, attached toilets and balconies.",
      image: goaFloorPlan03,
      alt: "Goa Villa floor plan showing master bedroom, guest bedroom and private spaces",
    },
  ],

  gallery: [
    // {
    //   image: riverstoneResidence,
    //   alt: "Goa Villa Residence exterior facade",
    //   caption: "Contemporary Goa villa architectural facade",
    // },
    // {
    //   image: featuredGallery01,
    //   alt: "Goa Villa outdoor area",
    //   caption: "Outdoor living and landscaped villa setting",
    // },
    // {
    //   image: featuredGallery02,
    //   alt: "Goa Villa interior living space",
    //   caption: "Open-plan living space with indoor-outdoor connection",
    // },

       {
      image: goaFloorRotate3,
      alt: "Goa Villa bedroom floor plan",
      caption: "03 — Private bedroom & retreat spaces",
    },

    {
      image: goaFloorRotate1,
      alt: "Goa Villa landscape floor plan",
      caption: "01 — Landscape, meditation & water features",
    },
    {
      image: goaFloorRotate2,
      alt: "Goa Villa living floor plan",
      caption: "02 — Living, dining & family spaces",
    },
 
  ],
},


  // "pastel-full-home-interior": {
  //   title: "Pastel Full Home Interior",
  //   category: "Residential Interior",
  //   facts: [
  //     { label: "Location", value: "Pune" },
  //     { label: "Year", value: "2026" },
  //     { label: "Area", value: "1600 sq ft" },
  //     { label: "Category", value: "Interior" },
  //     { label: "Services", value: "Full Interior Design" },
  //   ],
  //   heroImage: pastelLivingDining02,
  //   heroAlt: "Pastel living and dining room interior",
  //   overview:
  //     "A soft pastel full-home interior featuring coordinated living, dining, bedroom, wardrobe, and kitchen spaces. Designed with gentle tones, fluted panel details, and functional storage.",
  //   fullbleedImage: pastelLivingDining01,
  //   fullbleedAlt: "Pastel living area",
  //   fullbleedQuote: "Gentle tones and refined textures creating a tranquil sanctuary.",
  //   chapters: [
  //     {
  //       eyebrow: "01 - LIVING & DINING",
  //       title: "Harmonious Colors",
  //       body: "Pastel teal and muted rose accents bring warmth and light to the open-plan living and dining areas.",
  //       image: pastelLivingDining02,
  //       alt: "Living room pastel palette",
  //     },
  //     {
  //       eyebrow: "02 - KITCHEN DESIGN",
  //       title: "Modular Sophistication",
  //       body: "Custom pastel cabinets with matte finishes, quartz counter, and clever corner pull-out hardware.",
  //       image: pastelMainKitchen,
  //       alt: "Pastel kitchen interior",
  //     },
  //     {
  //       eyebrow: "03 - BEDROOM & STUDY",
  //       title: "Cozy Sanctuary",
  //       body: "Pastel bedroom with integrated study nook, floating shelves, and full-height wardrobe storage.",
  //       image: pastelBedroom,
  //       alt: "Pastel bedroom layout",
  //     },
  //   ],
  //   gallery: [
  //     {
  //       image: pastelLivingDining02,
  //       alt: "Pastel Living",
  //       caption: "Open-plan living room with pastel accent wall",
  //     },
  //     {
  //       image: pastelLivingDining01,
  //       alt: "Dining wall",
  //       caption: "Dining section with ambient wall sconce",
  //     },
  //     {
  //       image: pastelBedroom,
  //       alt: "Pastel Bedroom",
  //       caption: "Bedroom with study desk and custom wardrobe",
  //     },
  //     {
  //       image: pastelMainKitchen,
  //       alt: "Pastel Kitchen",
  //       caption: "Main kitchen with mint pastel cabinetry",
  //     },
  //   ],
  // },

  // "orchid-tv-kitchen-home": {
  //   title: "Orchid TV Unit & Kitchen Home",
  //   category: "Residential / Apartment",
  //   facts: [
  //     { label: "Location", value: "Pune" },
  //     { label: "Year", value: "2026" },
  //     { label: "Area", value: "1100 sq ft" },
  //     { label: "Category", value: "Interior" },
  //     { label: "Services", value: "Interior Execution" },
  //   ],
  //   heroImage: orchidLiving01,
  //   heroAlt: "Orchid apartment TV unit and living space",
  //   overview:
  //     "Executed apartment interiors featuring a curved TV unit, foyer entryway storage, custom cove ceiling lighting, and a modern compact green kitchen.",
  //   fullbleedImage: orchidTvUnit01,
  //   fullbleedAlt: "Curved TV unit detail",
  //   fullbleedQuote: "Fluid curves and tailored cabinetry crafted for contemporary living.",
  //   chapters: [
  //     {
  //       eyebrow: "01 - CURVED TV UNIT",
  //       title: "Statement Feature Wall",
  //       body: "Smooth fluted curves with indirect LED cove lighting frame the entertainment system elegantly.",
  //       image: orchidTvUnit01,
  //       alt: "Curved TV console wall",
  //     },
  //     {
  //       eyebrow: "02 - FOYER & STORAGE",
  //       title: "Welcoming Entrance",
  //       body: "Custom shoe cabinet with seat bench and vanity mirror panel near the entryway.",
  //       image: orchidFoyer01,
  //       alt: "Foyer storage cabinet",
  //     },
  //     {
  //       eyebrow: "03 - MODERN KITCHEN",
  //       title: "Sage & Marble",
  //       body: "Compact kitchen finished with sage green laminate, acrylic upper cabinets, and granite backsplash.",
  //       image: orchidKitchen01,
  //       alt: "Sage green modular kitchen",
  //     },
  //   ],
  //   gallery: [
  //     {
  //       image: orchidLiving01,
  //       alt: "Living room",
  //       caption: "Living room with custom TV backpanel",
  //     },
  //     {
  //       image: orchidTvUnit01,
  //       alt: "TV unit close up",
  //       caption: "Curved wall panel detail with LED strip light",
  //     },
  //     {
  //       image: orchidKitchen01,
  //       alt: "Kitchen layout",
  //       caption: "Modular kitchen with sleek handleless drawers",
  //     },
  //     {
  //       image: kidsStudyBedroom,
  //       alt: "Kids bedroom",
  //       caption: "Kids study and bedroom unit",
  //     },
  //   ],
  // },

  // "warm-wood-residence": {
  //   title: "Warm Wood Residence",
  //   category: "Residential Interior",
  //   facts: [
  //     { label: "Location", value: "Pune" },
  //     { label: "Year", value: "2026" },
  //     { label: "Area", value: "1450 sq ft" },
  //     { label: "Category", value: "Interior" },
  //     { label: "Services", value: "Full Interior Execution" },
  //   ],
  //   heroImage: warmLiving01,
  //   heroAlt: "Warm Wood Residence living room interior",
  //   overview:
  //     "Warm wood-led home interiors featuring master and guest bedrooms, living room TV wall paneling, modular kitchen, dining space, and built-in storage solutions.",
  //   fullbleedImage: warmBedroom01,
  //   fullbleedAlt: "Warm bedroom headboard design",
  //   fullbleedQuote: "The soothing texture of natural timber blended with modern lighting design.",
  //   chapters: [
  //     {
  //       eyebrow: "01 - LIVING AREA",
  //       title: "Timber Warmth",
  //       body: "Rich walnut veneer paneling combined with soft neutral sofa upholstery and warm ambient lighting.",
  //       image: warmLiving01,
  //       alt: "Living room timber paneling",
  //     },
  //     {
  //       eyebrow: "02 - MASTER BEDROOM",
  //       title: "Refined Sanctuary",
  //       body: "Full-height wardrobe with tinted glass doors, warm headboard panelling, and integrated nightstands.",
  //       image: warmBedroom01,
  //       alt: "Master bedroom design",
  //     },
  //     {
  //       eyebrow: "03 - DINING & KITCHEN",
  //       title: "Seamless Entertaining",
  //       body: "Coordinated dining space with wooden ceiling raft and adjacent modern parallel kitchen.",
  //       image: warmDining01,
  //       alt: "Dining area and wood raft",
  //     },
  //   ],
  //   gallery: [
  //     {
  //       image: warmLiving01,
  //       alt: "Living interior",
  //       caption: "Living room with walnut TV paneling",
  //     },
  //     {
  //       image: warmBedroom01,
  //       alt: "Master bedroom",
  //       caption: "Master suite with warm wood tones",
  //     },
  //     {
  //       image: warmKitchen01,
  //       alt: "Parallel kitchen",
  //       caption: "Parallel kitchen layout with matte finish",
  //     },
  //     {
  //       image: warmDining01,
  //       alt: "Dining section",
  //       caption: "Dining area featuring custom wood ceiling element",
  //     },
  //   ],
  // },

  // "latur-kalidas-sendkar": {
  //   title: "Proposed Mixed-Use Project",
  //   category: "Architecture & Mixed-Use",
  //   facts: [
  //     { label: "Location", value: "Latur" },
  //     { label: "Year", value: "2024" },
  //     { label: "Area", value: "4500 sq ft" },
  //     { label: "Category", value: "Architecture" },
  //     { label: "Services", value: "Architectural Planning & 3D" },
  //   ],
  //   heroImage: featuredGallery12,
  //   heroAlt: "Latur Mixed-Use building elevation visual",
  //   overview:
  //     "A thoughtfully planned mixed-use development featuring a ground-floor commercial clinic, a spacious duplex bungalow across the first and second floors, and two well-designed 1BHK residences on the top floor.",
  //   fullbleedImage: featuredGallery11,
  //   fullbleedAlt: "Commercial elevation angle",
  //   fullbleedQuote: "Blending commercial utility with premium residential living in one iconic structure.",
  //   chapters: [
  //     {
  //       eyebrow: "01 - GROUND FLOOR CLINIC",
  //       title: "Commercial Frontage",
  //       body: "The street level is designed with clear glass frontage, easy patient access, and prominent branding signage space.",
  //       image: featuredGallery11,
  //       alt: "Ground floor commercial clinic",
  //     },
  //     {
  //       eyebrow: "02 - DUPLEX BUNGALOW",
  //       title: "Family Residence",
  //       body: "First and second floors house a luxurious duplex residence with private balcony terraces and double-height living.",
  //       image: featuredGallery12,
  //       alt: "Duplex residential levels",
  //     },
  //     {
  //       eyebrow: "03 - TOP FLOOR APARTMENTS",
  //       title: "Rental 1BHK Units",
  //       body: "The top floor incorporates two independent 1BHK layouts optimized for rental income with separate elevator access.",
  //       image: featuredGallery15,
  //       alt: "Top floor residential level",
  //     },
  //   ],
  //   gallery: [
  //     {
  //       image: featuredGallery12,
  //       alt: "Full elevation",
  //       caption: "Front elevation rendering of the mixed-use building",
  //     },
  //     {
  //       image: featuredGallery11,
  //       alt: "Perspective angle",
  //       caption: "3D perspective view from street level",
  //     },
  //   ],
  // },

  // "manjari-swapnil-khopade": {
  //   title: "Proposed Residential Bungalow at Manjari",
  //   category: "Architecture & Bungalow",
  //   facts: [
  //     { label: "Location", value: "Manjari, Pune" },
  //     { label: "Year", value: "2024" },
  //     { label: "Area", value: "2800 sq ft" },
  //     { label: "Category", value: "Architecture" },
  //     { label: "Services", value: "Façade & Structural Design" },
  //   ],
  //   heroImage: featuredGallery16,
  //   heroAlt: "Manjari Bungalow modern elevation",
  //   overview:
  //     "A residential façade design with carefully composed elevations, balanced massing, elegant stone cladding details, and a timeless street presence.",
  //   fullbleedImage: featuredGallery15,
  //   fullbleedAlt: "Bungalow side perspective",
  //   fullbleedQuote: "Timeless architectural massing paired with natural stone and wood cladding.",
  //   chapters: [
  //     {
  //       eyebrow: "01 - ELEVATION MASSING",
  //       title: "Geometric Proportions",
  //       body: "Strong cantilevered slabs and vertical louvers break up the mass while providing solar shading.",
  //       image: featuredGallery16,
  //       alt: "Front elevation model",
  //     },
  //     {
  //       eyebrow: "02 - MATERIAL PALETTE",
  //       title: "Natural Stone & Wood",
  //       body: "Exterior palette combines warm travertine stone, dark metal window frames, and teak louver screens.",
  //       image: featuredGallery15,
  //       alt: "Material detail shot",
  //     },
  //   ],
  //   gallery: [
  //     {
  //       image: featuredGallery16,
  //       alt: "Front view",
  //       caption: "3D visualization of front elevation",
  //     },
  //     {
  //       image: featuredGallery15,
  //       alt: "Angle view",
  //       caption: "Side balcony and cantilever detail",
  //     },
  //   ],
  // },

  // "studio-apartment-katraj": {
  //   title: "Katraj Project - Studio Apartment",
  //   category: "Architecture & Compact Living",
  //   facts: [
  //     { label: "Location", value: "Katraj, Pune" },
  //     { label: "Year", value: "2024" },
  //     { label: "Area", value: "500 sq ft" },
  //     { label: "Category", value: "Architecture" },
  //     { label: "Services", value: "Space Planning" },
  //   ],
  //   heroImage: featuredGallery18,
  //   heroAlt: "Katraj Studio Apartment building elevation",
  //   overview:
  //     "A compact studio apartment layout focused on efficient space planning, smart convertible furniture, multi-purpose storage, and modern architectural exterior massing.",
  //   fullbleedImage: featuredGallery17,
  //   fullbleedAlt: "Studio apartment exterior detail",
  //   fullbleedQuote: "Smart compact design maximizing every square foot of urban living.",
  //   chapters: [
  //     {
  //       eyebrow: "01 - COMPACT EFFICIENCY",
  //       title: "Smart Space Optimization",
  //       body: "Every inch is engineered for multi-functionality, with foldaway beds, integrated desks, and sliding partition panels.",
  //       image: featuredGallery18,
  //       alt: "Studio apartment spatial rendering",
  //     },
  //     {
  //       eyebrow: "02 - EXTERNAL ELEVATION",
  //       title: "Modern Facade",
  //       body: "Clean white exterior finish accented with dark window frames and vertical green balcony planters.",
  //       image: featuredGallery17,
  //       alt: "Building facade visual",
  //     },
  //   ],
  //   gallery: [
  //     {
  //       image: featuredGallery18,
  //       alt: "Studio exterior",
  //       caption: "3D visual of the Katraj Studio building",
  //     },
  //     {
  //       image: featuredGallery17,
  //       alt: "Balcony detail",
  //       caption: "Balcony planter and louver detail",
  //     },
  //   ],
  // },

  // "ved-estate-commercial": {
  //   title: "VED Estate Commercial Complex",
  //   category: "Commercial Architecture",
  //   facts: [
  //     { label: "Location", value: "Pune" },
  //     { label: "Year", value: "2026" },
  //     { label: "Area", value: "5200 sq ft" },
  //     { label: "Category", value: "Commercial" },
  //     { label: "Services", value: "Facade & Architectural Design" },
  //   ],
  //   heroImage: vedEstate01,
  //   heroAlt: "VED Estate Commercial facade visual",
  //   overview:
  //     "A commercial facade with striking glass frontage, bold red architectural accent volumes, and a strong street-level presence for maximum retail and office visibility.",
  //   fullbleedImage: vedEstate02,
  //   fullbleedAlt: "VED Estate commercial elevation night view",
  //   fullbleedQuote: "A bold commercial landmark engineered for high-street visibility and retail impact.",
  //   chapters: [
  //     {
  //       eyebrow: "01 - STREET PRESENCE",
  //       title: "Bold Landmark",
  //       body: "High-contrast red aluminum composite panels combined with double-glazed curtain glass walls.",
  //       image: vedEstate01,
  //       alt: "Commercial facade front view",
  //     },
  //     {
  //       eyebrow: "02 - GLAZING & ILLUMINATION",
  //       title: "Nighttime Identity",
  //       body: "Integrated LED linear facade lighting turns the building into a glowing urban beacon after dark.",
  //       image: vedEstate02,
  //       alt: "Night perspective rendering",
  //     },
  //   ],
  //   gallery: [
  //     {
  //       image: vedEstate01,
  //       alt: "Front facade",
  //       caption: "Commercial facade with glass frontage",
  //     },
  //     {
  //       image: vedEstate02,
  //       alt: "Night facade view",
  //       caption: "Night visual with integrated facade lighting",
  //     },
  //   ],
  // },

  // "nagpur-commercial-elevation": {
  //   title: "Proposed Mixed-Use Development at Nagpur",
  //   category: "Commercial Architecture",
  //   facts: [
  //     { label: "Location", value: "Nagpur" },
  //     { label: "Year", value: "2026" },
  //     { label: "Area", value: "6000 sq ft" },
  //     { label: "Category", value: "Commercial & Retail" },
  //     { label: "Services", value: "Architectural Planning" },
  //   ],
  //   heroImage: nagpurCommercialElevation,
  //   heroAlt: "Nagpur Commercial building elevation",
  //   overview:
  //     "Mixed-use commercial elevation with yellow facade massing, expansive glass frontage, and a strong roofline identity designed to command attention along a busy avenue.",
  //   fullbleedImage: nagpurCommercialElevation,
  //   fullbleedAlt: "Nagpur commercial visual",
  //   fullbleedQuote: "Vibrant architectural massing crafted to stand out on commercial corridors.",
  //   chapters: [
  //     {
  //       eyebrow: "01 - FACADE CONCEPT",
  //       title: "Dynamic Colors",
  //       body: "Warm yellow architectural framing surrounds glass shopfronts, giving the building an energetic identity.",
  //       image: nagpurCommercialElevation,
  //       alt: "Nagpur building front visual",
  //     },
  //   ],
  //   gallery: [
  //     {
  //       image: nagpurCommercialElevation,
  //       alt: "Full elevation rendering",
  //       caption: "Mixed-use elevation with yellow accent framing",
  //     },
  //   ],
  // },


};

export const PROJECT_ORDER = Object.keys(PROJECT_DETAILS);
